import PropTypes from "prop-types"
import React from "react"
import Button from "./button"
import { useForm } from "react-hook-form"
import Field from "./form/field"
import FormData from 'form-data';

function sendForm(formData) {
  return fetch('/api/contact-form', {
    method: 'POST',
    headers: {
      "Access-Control-Allow-Headers": "*",
    },
    body: formData,
  }).then(res => res.json())
}

const ContactForm = () => {
  const { register, handleSubmit, watch, errors } = useForm()
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [isSubmitted, setIsSubmitted] = React.useState(false)
  const [selectedFiles, setSelectedFiles] = React.useState([]);

  const onSubmit = async payload => {
    setIsSubmitting(true)

    const formData = new FormData();
    formData.append('name', payload.name);
    formData.append('email', payload.email);
    formData.append('message', payload.message);
    formData.append('phone', payload.phone);

    selectedFiles.forEach((file) =>
      formData.append("file", file)
    );

    try {
      const { errors, success } = await sendForm(formData);

      setIsSubmitted(true)
    } catch (e) {
      console.log(e)
    }

    setIsSubmitting(false)
  }

  return (
    <div className="">
      <div className="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:py-8">
        <form
          className={`mt-8 sm:grid-cols-2 gap-2.5 sm:gap-5 flex flex-col ${
            isSubmitted ? "hidden" : "sm:grid"
          }`}
          style={{ '--label-background': '#FCF9F6' }}
          onSubmit={handleSubmit(onSubmit)}
          encType="multipart/form-data"
        >
          <div className="bg-white rounded-xl p-4">
            <Field
              className="mb-8 sm:mb-0"
              name="name"
              label="Name"
              placeholder="Ex. Louise"
              register={register}
              required={true}
              errors={errors}
              inputPostfix={"contact-form"}
            />
          </div>
          <div className="bg-white rounded-xl p-4">
          <Field
            className="mb-8 sm:mb-0"
            name="email"
            type="email"
            label="Email"
            placeholder="Ex. louise@gmail.com"
            register={register}
            required={true}
            errors={errors}
            inputPostfix={"contact-form"}
          />
          </div>
          <div className="bg-white rounded-xl p-4">
          <Field
            className="mb-8 sm:mb-0"
            name="phone"
            label="Phone"
            placeholder="Ex. 555-555-5555"
            register={register}
            required={true}
            inputPostfix={"contact-form"}
            errors={errors}
          />
          </div>
          <div className="bg-white rounded-xl p-4">
          <Field
            className="mb-8 sm:mb-0"
            name="orderNumber"
            label="Order Number"
            placeholder="Ex. 00000"
            register={register}
            required={false}
            inputPostfix={"contact-form"}
            errors={errors}
          />
          </div>
          <div className="bg-white rounded-xl p-4 sm:col-span-2">
          <Field
            className="mb-8 sm:mb-0"
            inputPostfix={"contact-form"}
            type="textarea"
            name="message"
            label="Message"
            rows="4"
            placeholder="Hi there, I love your crate!"
            register={register}
            required={true}
            errors={errors}
          />
          </div>
          <div className="bg-white rounded-xl p-4 sm:col-span-2 relative">
          <Field
            className="mb-8 sm:mb-0"
            inputPostfix={"contact-form"}
            type="file"
            name="files"
            label="Attachments:"
            multiple={true}
            register={register}
            errors={errors}
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
          />
          </div>

          <div className="sm:col-start-2 flex justify-center md:ml-40">
            <Button buttonType="submit" disabled={isSubmitting} isLoading={isSubmitting} loadingText="Sending..." theme={{desktop: 'btn-secondary', mobile: 'btn-secondary'}}>
              Send Message
            </Button>
          </div>
        </form>
        <div className={`text-center ${isSubmitted ? "" : "hidden"}`}>
          <p className="text-dark-navy text-3xl leading-9 font-bold sm:text-3xl sm:leading-10 antialiased md:py-12">
            Thanks, we will get back to you within 1 business day.
          </p>
        </div>
      </div>
    </div>
  )
}

ContactForm.propTypes = {
  siteTitle: PropTypes.string,
}

export default ContactForm
